export const isAuthenticatedSelector = state => state.auth.isAuthenticated;
export const emailSelector = state => state.auth?.user?.email;
export const phoneSelector = state => state.auth?.user?.phone;
export const userAuthSelector = state => state.auth?.user;
export const authSelector = state => state.auth;
export const getVerifyCodeSelector = state => state.auth?.getVerifyCode;
export const couponSelector = state => state.auth?.user?.coupon;
export const codeSelector = state => state.auth?.user?.code;
export const sourceSelector = state => state.auth?.user?.source;
